import React, { ChangeEvent, useCallback, useEffect } from 'react';

import { Form, FormInstance, Input } from 'antd';
import { useSetRecoilState } from 'recoil';

import { useQueryResultsFromHash } from 'hooks/use-query.state';

import { previewState } from '../../state/preview';

const { Item } = Form;

export default function Name({ hash, form }: { hash: string; form: FormInstance }) {
  const collection = useQueryResultsFromHash(hash);
  const updatePreview = useSetRecoilState(previewState);
  const name = collection?.name;

  const onChange = useCallback((event: ChangeEvent<any>) => {
    updatePreview((preview) => {
      return { ...preview, name: event.target.value };
    });
  }, []);

  useEffect(() => {
    if (name) {
      form.setFieldsValue({
        name,
      });

      updatePreview((preview) => {
        return {
          ...preview,
          name,
        };
      });
    }
  }, [name]);

  return (
    <Item label="Name" required name="name" extra="Name extracted from the nft token">
      <Input readOnly={!!name} onChange={onChange} />
    </Item>
  );
}
